const Details = [
  {
    id: 0,
    title: "Phase 1",
    desc: "Mint Stage 1",
    sub: "We launch on the Polygon network on February 21st 2023.",
  },
  {
    id: 1,
    title: "Phase 2 ",
    desc: "Mint Stage 2",
    sub: "The remaining 1000 / 10000 YooBs For Mint with a mint price of 1 Matic!. Remaning will be minted for 2 Matic",
  },
  {
    id: 2,
    title: "Phase 3",
    desc: "Team & Community Building",
    sub: "The YooBs team would love to hear if you have any suggestions or ideas To learn a bit about the team members we have working on the project please join Discord section below",
  },
  {
    id: 3,
    title: "Phase 4",
    desc: "Giveaways/Collabs/Partnerships",
    sub: "We look to continue collaborating, and creating partnerships among other Polygon projects. We are excited to have already made friendships, and partnerships with the likes of projects such as UMBRIA NETWORK, CRYPTOMIBS, POLYGON ALLIANCE, and more! Be sure to join and follow with notifications on! If you have a project that would like to collaborate with YooBs, please contact one of our team members to move forward!",
  },
  {
    id: 4,
    title: "Phase 5",
    desc: "YooBs Discord Ecosystem",
    sub: "We've integrated a Discord ecosystem providing rewards and opportunities for YooBs NFT holders to claim exclusive YooBs merch, prizes, whitelist, NFTs, and more! Holders rally here to collect Honey Hut tokens, chat, play games with other members, and access exclusive raffles & giveaways! We are also currently looking to provide holders utility in the form of alpha, trackers, callers, and even more tools in the future.",
  },
  {
    id: 5,
    title: "Phase 6 ",
    desc: "Honey Hut",
    sub: "YooBs NFT holders can collect honey daily in the YooBs server, and gain access to the Honey Hut. Here you can spend your Honeys on various items, ranging from other project's NFTs, to physical merch, and gift cards. This is where holders will also buy tickets, to enter monthly YooBs raffles!",
  },
  {
    id: 6,
    title: "Phase 7",
    desc: "YooBs Merch",
    sub: "We've been dabbling with merchandise & designs, and giving it away to holders via raffles, mints, and giveaways as we go. We've given away YooBs merch hoodies, t-shirts, mugs, canvases, and more to come. If you hold a YooBs NFT, join the Discord server to get involved!.In the future, we look to deploy YooB's very own merch store, where holders can redeem exclusive merch and designs, and eventually integrate discount utility within the store!",
  },
  {
    id: 7,
    title: "Phase 8",
    desc: "To Be Continued...",
    sub: "Will Be Updated Soon",
  },
  
];

export default Details;
